'use client';

import { Stack, Typography } from '@mui/material';
import { JobStatus } from '@repo/api-gw-sdk';
import type { ReactNode } from 'react';

import { JobStatuses } from '@/data/inventory/data';

type CheckStatus = 'ok' | 'error' | 'pending';

interface CheckResultRowProps {
  status: CheckStatus;
  label: string;
  children?: ReactNode;
}

const checkStatusToJobStatus: Record<CheckStatus, JobStatus> = {
  ok: JobStatus.JOB_COMPLETED,
  error: JobStatus.JOB_FAILED,
  pending: JobStatus.JOB_PENDING,
};

export const CheckResultRow = ({
  status,
  label,
  children,
}: CheckResultRowProps) => {
  const jobStatus = JobStatuses[checkStatusToJobStatus[status]];
  return (
    <Stack direction='row' gap='8px' alignItems='flex-start'>
      <i
        className={`${jobStatus?.icon} text-2xl`}
        style={{ color: jobStatus?.iconColor }}
      />
      <Stack gap='4px' flex={1}>
        <Typography variant='subtitle2'>{label}</Typography>
        {children}
      </Stack>
    </Stack>
  );
};
